// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const infernape: PokeData = {
  "id": 392,
  "name": "infernape",
  "height": 12,
  "weight": 550,
  "base_experience": 240,
  "types": [
    PokeType.FIRE,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "scratch",
    "tackle",
    "double-edge",
    "leer",
    "ember",
    "flamethrower",
    "fire-spin",
    "swift",
    "fury-swipes",
    "flame-wheel",
    "mach-punch",
    "torment",
    "facade",
    "taunt",
    "slack-off",
    "calm-mind",
    "feint",
    "u-turn",
    "close-combat",
    "punishment",
    "flare-blitz",
    "nasty-plot",
    "acrobatics",
    "power-up-punch",
    "raging-fury"
  ],
  "moves": [
    "scratch",
    "tackle",
    "leer",
    "ember",
    "flamethrower",
    "fire-spin",
    "calm-mind",
    "close-combat",
    "flare-blitz",
    "acrobatics",
    "morning-sun",
    "jump-kick",
    "eruption"
  ],
  "evolution_chain": {
    "id": 204,
    "item": null,
    "species": [
      {
        "name": "chimchar",
        "order": 420,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "monferno",
        "order": 421,
        "types": [
          PokeType.FIRE,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 390,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 14,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "infernape",
        "order": 422,
        "types": [
          PokeType.FIRE,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 391,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 103,
    "speed": 151,
    "ability_power": 146
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
